module.exports = __webpack_public_path__ + "56bfd07406a741f3396e64e8634088ae.png";